"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * CompetitorPriceHistoryIndexDTOConverter
 *
 * @author RV
 */


var CompetitorPriceHistoryIndexDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorPriceHistoryIndexDTOConverter, _DataObjectConverter_);

  function CompetitorPriceHistoryIndexDTOConverter() {
    _classCallCheck(this, CompetitorPriceHistoryIndexDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceHistoryIndexDTOConverter).apply(this, arguments));
  }

  return CompetitorPriceHistoryIndexDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorPriceHistoryIndexDTOConverter = CompetitorPriceHistoryIndexDTOConverter;